import { yup } from '@guiker/yup-util'

export const listingInquiryIdPathParamSchema = yup.object({
  listingInquiryId: yup.string().required(),
})

export type ListingInquiryIdPathParamSchema = yup.InferType<typeof listingInquiryIdPathParamSchema>
